import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";

export default function FaqPage() {
  return (
    <>
      <Seo title="FAQ" description="Answers to common questions about utipanagecy services, pricing, PSA activation, white label and API." />
      <PageHeader eyebrow="FAQ" title="Questions? We've got answers" sub="Everything you need to know about getting started with utipanagecy." />
      <Section testId="faq-page">
        <FAQ />
      </Section>
      <CTA />
    </>
  );
}
